import { message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import {
  fetchCompanyById,
  updateCompanyById,
} from "../../../lib/api/resources/companies";
import { useNavigate, useParams } from "react-router-dom";
import { CompanyFormCard } from "./components/CompanyForm";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";

export type CompanyEditValues = Omit<Company, "servicePartners"> & {
  servicePartners: string[];
};

export const CompanyEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const companyQuery = useQuery({
    queryKey: ["company", id],
    queryFn: async (): Promise<CompanyEditValues> => {
      if (!id) {
        throw new Error("No company ID provided");
      }
      const company = await fetchCompanyById(id);
      const servicePartners =
        company?.servicePartners?.map(
          (servicePartner: Partial<ServicePartner>) => servicePartner.id,
        ) || [];
      company.servicePartners = servicePartners as string[];
      return company as CompanyEditValues;
    },
  });

  const updateCompanyMutation = useMutation({
    mutationFn: (data: CompanyEditValues) => updateCompanyById(id, data),
    onSuccess: () => {
      navigate(`/companies/${id}`);
      message.success("Bedrijf succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van het bedrijf",
      ),
  });

  return (
    <div>
      <CompanyFormCard
        loading={companyQuery.isLoading}
        initialValues={companyQuery.data}
        mutation={updateCompanyMutation}
        title="Bedrijf bijwerken"
        buttonText="Bijwerken"
      />
    </div>
  );
};
